import { useEffect, useState } from "react";
import { resolveSiteAssetUrl, useSiteSettings } from "../lib/site-settings";

export interface SplashScreenProps {
  readonly onComplete?: () => void;
}

export function SplashScreen({ onComplete }: SplashScreenProps) {
  const [fading, setFading] = useState(false);
  const settings = useSiteSettings();

  useEffect(() => {
    // Start fading out after 1200ms — uses CSS splash-out animation
    const fadeTimer = setTimeout(() => {
      setFading(true);
    }, 1200);

    // Trigger complete callback after 1700ms (500ms animation time)
    const completeTimer = setTimeout(() => {
      onComplete?.();
    }, 1700);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div className={`splash-screen ${fading ? "fade-out" : ""}`}>
      <div className="splash-content">
        <img src={resolveSiteAssetUrl(settings.mobileSplashLogo)} alt={`${settings.siteName} Logo`} className="splash-logo" />
        <p className="splash-subtitle">{settings.siteDescription}</p>
      </div>
    </div>
  );
}
